import React from "react";
import { useNavigation } from "@react-navigation/native";
import { useSurgeries } from "../SurgeriesContext";
import { useQueuedPatientUpdate } from "@src/packages/patients/sync/usePatientSync";
import { transformSurgeriesStateToRequest } from "../transformSurgeriesStateToRequest";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@src/packages/medical-history/components/BaseCompleteScreen";
import { useTranslations } from "@src/packages/i18n";

export function SurgeriesCompleteScreen() {
  const t = useTranslations();
  const { state } = useSurgeries();
  const navigation = useNavigation();
  const { mutateAsync: updatePatient, isPending } = useQueuedPatientUpdate();

  const handleFinish = async () => {
    try {
      const payload = transformSurgeriesStateToRequest(state, t);
      await updatePatient(payload);
      navigateToNextSection(navigation, "surgeries");
    } catch {}
  };

  return (
    <BaseCompleteScreen
      subtitle={t("med_history.medical.surgeries.complete_subtitle")}
      buttonLabel={getNextSectionButtonLabel(t, "surgeries")}
      isSubmitting={isPending}
      onFinish={handleFinish}
    />
  );
}
